import { Asset } from 'expo-asset'
import { useEffect, useState } from 'react'
import { Platform } from 'react-native'
import AudioRecording, { AudioRecordingProps } from '~components/AudioRecording'

const CacheableAudioRecording = ({ source, ...props }: AudioRecordingProps) => {
  const [busy, setBusy] = useState(source?.uri && Platform.OS !== 'web' ? true : false)
  const [localSource, setLocalSource] = useState<AudioRecordingProps['source']>(
    source?.uri && Platform.OS === 'web' ? { uri: source.uri } : undefined,
  )

  useEffect(() => {
    let cancel = false

    if (Platform.OS !== 'web') {
      if (source?.uri) {
        Asset.fromURI(source.uri)
          .downloadAsync()
          .then(({ localUri }) => {
            if (!cancel) {
              if (localUri) {
                setLocalSource({ uri: localUri })
              }
              setBusy(false)
            }
          })
          .catch((error) => {
            if (!cancel) {
              console.error('Error downloading asset:', error)
              setBusy(false)
            }
          })
      } else {
        // If no source is provided, clear the local source
        setLocalSource(undefined)
        setBusy(false)
      }
    } else {
      setLocalSource(source)
    }

    return () => {
      cancel = true
    }
  }, [source])

  return <AudioRecording {...props} source={localSource} readonly={props.readonly || busy} />
}

export { CacheableAudioRecording }
